exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".box{margin-top:30px}.uc{text-transform:uppercase}", "", {"version":3,"sources":["/opt/build/repo/src/components/Views.vue"],"names":[],"mappings":"AACA,KACI,eAAgB,CACnB,AACD,IACI,wBAA0B,CAC7B","file":"Views.vue","sourcesContent":["\n.box {\n    margin-top:30px;\n}\n.uc {\n    text-transform: uppercase;\n}\n/*  .hero-size {\n    padding-bottom: 14rem;\n    padding-top: 14rem;\n    background-color: red;\n    overflow: hidden;\n  }\n@media all and (max-width: 400px) {\n.hero-size {\n    padding-bottom: 2rem;\n    padding-top: 2rem;\n}\n}*/\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63e33b7c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Views.vue
// module id = 672
// module chunks = 1